// src/services/api/area.service.ts
import api from '../index';
import { Area, AreaFilters } from '../../types/notification'
export const areaService = {
  getAll: (filters?: AreaFilters) => 
    api.get<Area[]>('/areas', { params: filters }),

  getById: (id: number) => 
    api.get<Area>(`/areas/${id}`),

  create: (data: Partial<Area>) => 
    api.post<Area>('/areas', data),

  update: (id: number, data: Partial<Area>) => 
    api.put<Area>(`/areas/${id}`, data),

  delete: (id: number) => 
    api.delete(`/areas/${id}`)
};

export default areaService;